import { useQuery } from '@apollo/client';
import { CreateFeatures } from 'components/minute/layout/CreateMinuteBody/CreateFeatures';
import { CreateMinuteContinue } from 'components/minute/layout/CreateMinuteBody/CreateMinuteContinue';
import { CreateMinuteStart } from 'components/minute/layout/CreateMinuteBody/CreateMinuteStart';
import { CreateShowcase } from 'components/minute/layout/CreateMinuteBody/CreateShowcase';
import { MinutePageTitle } from 'components/minute/layout/MinutePageTitle';
import { WorldMap, WorldMapVariables } from 'graphql/query/__generated__/WorldMap';
import { WORLD_MAP_QUERY } from 'graphql/query/worldQuery';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';
import { EColors, EFonts } from 'libs/styles/styling';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useContext } from 'react';
import { GlobalContext } from 'session/state/context';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    onContinue: (name: string) => void;
    className?: string;
}

export const CreateMinuteBody = (props: Props): JSX.Element => {
    const isWide = useIsWide();
    const localStorage = useWorldMapLocalStorage();
    const {
        state: { loggedUser }
    } = useContext(GlobalContext);

    const createdMaps = localStorage.getListOfMaps();
    const mapIdInCreation = createdMaps[createdMaps.length - 1];
    const showContinue = !loggedUser && mapIdInCreation;

    const mapInCreation = useQuery<WorldMap, WorldMapVariables>(WORLD_MAP_QUERY, {
        variables: {
            worldMapId: mapIdInCreation,
            token: localStorage.getTokenForMapId(mapIdInCreation)
        },
        skip: !showContinue
    });

    return (
        <S_CreateMinuteBody className={props.className}>
            <MinutePageTitle title={Localization.MAIN_H1} subtitle={Localization.MAIN_H2} />
            {showContinue ? (
                <CreateMinuteContinue map={mapInCreation.data?.worldMap} />
            ) : (
                <CreateMinuteStart onContinue={props.onContinue} />
            )}
            {isWide && (
                <>
                    <S_Subtitle>{Localization.YOUR_POSSIBILITIES}</S_Subtitle>
                    <S_CreateFeatures />
                    <S_Subtitle2>{Localization.GET_YOUR_INSPIRATION}</S_Subtitle2>
                    <S_CreateShowcase />
                </>
            )}
        </S_CreateMinuteBody>
    );
};

const S_CreateMinuteBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const S_Subtitle = styled.div`
    margin: 140px 0px 20px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Bold};
    font-size: 26px;
    letter-spacing: -0.03em;
    padding: 0 20px;
`;

const S_Subtitle2 = styled.div`
    margin: 50px 0px 20px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Bold};
    font-size: 26px;
    letter-spacing: -0.03em;
    padding: 0 20px;
`;

const S_CreateShowcase = styled(CreateShowcase)`
    margin: 30px 0 0 0;
`;

const S_CreateFeatures = styled(CreateFeatures)``;
